import React, { memo } from 'react';

const BigDocument = memo(({ size = 70 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.25">
        <path
          d="M58.3337 19.5418V58.3335C58.3337 61.5418 55.592 64.1668 52.2087 64.1668H17.792C14.4378 64.1668 11.667 61.5418 11.667 58.3335V11.6668C11.667 8.4585 14.4087 5.8335 17.792 5.8335H43.2253"
          stroke="#D2552B"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M58.3349 19.5418L43.2266 5.8335"
          stroke="#D2552B"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7617 39.4321H47.5159"
          stroke="#D2552B"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7617 48.564H34.6242"
          stroke="#D2552B"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7617 30.3345H47.5159"
          stroke="#D2552B"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});

export default BigDocument;
